var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"bottom-icon row"},[_c('a',{attrs:{"href":"tel:0922047781","id":"phoneIcon"}}),_c('a',{attrs:{"href":"javascript:void(0)","id":"lineIcon"},on:{"click":_vm.contactLine}}),_c('a',{attrs:{"href":"javascript:void(0)","id":"telegramIcon"},on:{"click":_vm.contactTelegram}})])
}
var staticRenderFns = []

export { render, staticRenderFns }